import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './CustomerSummary.css';
import { useTranslation } from 'react-i18next';
import { Divider, Button, TextField } from '@material-ui/core';
import { setCheckoutStep } from '../../../actions/actionCreators';
import CartService from '../../../services/CartService';

const CustomerSummary = () => {
  const cart = useSelector(state => state.cartReducer);
  const mainColor = useSelector(state => state.frontConfigReducer.color);
  const [email, setEmail] = useState(cart.customer.email);
  const address = `${cart.shipping_address.address1}, ${cart.shipping_address.city},  ${cart.shipping_address.country}`;
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const changeAddress = () => {
    dispatch(setCheckoutStep(1));
  }

  return (
    <div className="AddressSummaryContainer">
      <div className="SummaryItem">
        <p className="SummaryTitle" >{t("Email")}</p>
        <p>{email}</p>
      </div>
      <Divider />
      <div className="SummaryItem">
        <p className="SummaryTitle">{t("Address")}</p>
        <p>{address}</p>
        <Button
          style={{ marginLeft: 'auto', color: mainColor, textTransform: 'none' }}
          onClick={changeAddress}>
          {t("Change")}
        </Button>
      </div>
    </div>
  )

}

export default CustomerSummary